// extracted by mini-css-extract-plugin
export default {"wrapper":"hdpVT","banner":"mkNLT","image":"F3feP","text":"quqLN","link":"dDG5v","inversed":"svyfY","title":"kCY28","subtitle":"vJyv8"};